// extracted by mini-css-extract-plugin
export default {"fade-out":"AssessmentStepTransition_fade-out__dIOj7","fade-in":"AssessmentStepTransition_fade-in__MpEZz"};